import React, { useEffect, useContext,useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box'
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import CheckBoxOutlineBlankTwoToneIcon from '@material-ui/icons/CheckBoxOutlineBlankTwoTone';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Hidden from '@material-ui/core/Hidden';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import ActivityContext from '../../context/activity-context'
import useStyles from '../../styles/components/learningcontent/stylesAssessmentHolder'
import { updateActivityCompletionRecord } from '../../actions/activity-actions'

import { getActivityStartTime, setActivityStartTime } from '../../utils/helpers/others/SessionHelper';
import CustomDialog from './CustomDialog'
import { TextareaAutosize } from '@material-ui/core';

import SunEditor,{buttonList} from "suneditor-react";
import align from 'suneditor/src/plugins/submenu/align'
import blockquote from 'suneditor/src/plugins/command/blockquote'
import font from'suneditor/src/plugins/submenu/font'
import fontColor from 'suneditor/src/plugins/submenu/fontColor'
import fontSize from 'suneditor/src/plugins/submenu/fontSize'
import formatBlock from 'suneditor/src/plugins/submenu/formatBlock'
import hiliteColor from 'suneditor/src/plugins/submenu/hiliteColor'
import horizontalRule from 'suneditor/src/plugins/submenu/horizontalRule'
import lineHeight from 'suneditor/src/plugins/submenu/lineHeight'
import list from 'suneditor/src/plugins/submenu/list'
import table from 'suneditor/src/plugins/submenu/table'
import textStyle from 'suneditor/src/plugins/submenu/textStyle'
import paragraphStyle from 'suneditor/src/plugins/submenu/paragraphStyle';
import 'suneditor/dist/css/suneditor.min.css';

const AssessmentContainer = () => {

    const classes = useStyles();
    const { activityContext, challengeId, dispatch } = useContext(ActivityContext);
    const [snackBarDetails, setSnackBarDetails] = useState({
        open: false,
        message: '',
        type: '',
    });

    const [sameAnswerFlag, setSameAnswerFlag] = useState(false);
    const [confirmFlag, setConfirmFlag] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [submitData, setSubmitData] = useState({});

    const handleCloseConfirmDialog = () =>{
        setConfirmMessage("");
        setSameAnswerFlag(false);
        setConfirmFlag(false);
        setSubmitData({});
        dispatch({
            type: 'SET_CUSTOMDIALOG', customDialog: {
                open: false,
                message: 'Please wait for a while...',
                severity: 'info',
                isLoading: false
            }
        });
    }



    const handleSnackBarClose = () => setSnackBarDetails({ ...snackBarDetails, open: false });

    const inputSnackBarDetails = (message, type) => setSnackBarDetails({
        open: true,
        message,
        type
    });

    const [disableSubmit, setDisableSubmit] = useState(false);

    useEffect(() => {
    }, []);

    const getCurrentAnswerObject = (items, selectedValue) => {
        
        let item = items.find((item) => {
            if (item.Id === parseInt(selectedValue))
            {   
                return item;
            }
        })
        return item;
    }

    const handleChange = event => dispatch({ type: 'SET_SECRET_CODE', secretCode: event.target.value });

    const handleOpenAnswerChange = (question,answer) => event =>{
        //find the question
        var contentToCheck = activityContext.openEndedAnswers;
        contentToCheck[question].answer = event;
        dispatch({type:'SET_OPENENDED_ANSWERS',openEndedAnswers:contentToCheck}); 
        setDisableSubmit(false); 
    }

    const handleChangeCheckbox = (answer, content) => event => {
        let size = 0;
        content.answers.forEach(element => {
            if (element.isChecked) size += 1
        });
        let limit = content.limit
        if (answer.isChecked) {
            answer.isChecked = false
        }
        else if (size < limit || limit <= 0) {
            answer.isChecked = true
        }
        dispatch({ type: 'SET_MULTIPLECHOICE_CONTENTS', multipleChoiceContents: activityContext.multipleChoiceContents });
    };

    const handleConfirmSubmit = async () =>{
        let response = await updateActivityCompletionRecord(JSON.stringify(submitData))
        if (response.status === "Success") {
            setActivityStartTime(0);
            dispatch({
                type: 'SET_CUSTOMDIALOG', customDialog: {
                    open: true,
                    message: 'Your answers have been submitted. You can attempt this assessment multiple times. Do note that time will continue to be tracked.',
                    severity: 'success',
                    isLoading: false
                }
            });

            //history.push(`/ChallengeDetail/${challengeId}`);
        }
        else {
            setActivityStartTime(0);
            dispatch({
                type: 'SET_CUSTOMDIALOG', customDialog: {
                    open: true,
                    message: "Unexpected error occured when submitting the assessment, Please try again later!",
                    severity: 'error',
                    isLoading: false
                }
            });
        }
        
    }

    const clickSubmitAssessment = () => {
        let selectedAnswerModels = processSelectedAnswer();
        let answerBlankOrSameAsHistory = [];
        let openEndedAnswerModels = processOpenEndedAnswers(answerBlankOrSameAsHistory);
        
        const startTime = getActivityStartTime();
        const endTime = new Date().getTime();
        let duration = Math.round((endTime - startTime) / 1000);
        let data = {
            ActivityId: activityContext.activity.ActivityId,
            MemberId: activityContext.activity.MemberId,
            IsCheating: false,
            TimeTaken: duration,
            AssessmentType: activityContext.activity.AssessmentType,
            SelectedAnswerModels: selectedAnswerModels,
            OpenEndedAnswerModels: openEndedAnswerModels
        }
        let confirmSubmit = true;
        if (selectedAnswerModels.length > 0 || openEndedAnswerModels.length > 0) {
            //console.log("Final Model", data)
            // dispatch({
            //     type: 'SET_CUSTOMDIALOG', customDialog: {
            //         open: true,
            //         message: 'Please wait for a while...',
            //         severity: 'info',
            //         isLoading: true
            //     }
            // });

            setConfirmFlag(true);
            setSubmitData(data);
            

            if(answerBlankOrSameAsHistory.length !== 0){
                let message = "The following questions are either same as your previous or blank : [";
                answerBlankOrSameAsHistory.forEach(same=>{
                    message = message + same + ", ";
                });
                message = message + "] Are you sure you want to continue?";
                // confirmSubmit = confirm(message);
                setSameAnswerFlag(true);
                setConfirmMessage(message);
            }
            // if(confirmSubmit){
            //     let response = await updateActivityCompletionRecord(JSON.stringify(data))
            //     if (response.status === "Success") {
            //         setActivityStartTime(0);
            //         dispatch({
            //             type: 'SET_CUSTOMDIALOG', customDialog: {
            //                 open: true,
            //                 message: 'Your answers have been submitted. You can attempt this assessment multiple times. Do note that time will continue to be tracked.',
            //                 severity: 'success',
            //                 isLoading: false
            //             }
            //         });
            //         //history.push(`/ChallengeDetail/${challengeId}`);
            //     }
            //     else {
            //         setActivityStartTime(0);
            //         dispatch({
            //             type: 'SET_CUSTOMDIALOG', customDialog: {
            //                 open: true,
            //                 message: "Unexpected error occured when submitting the assessment, Please try again later!",
            //                 severity: 'error',
            //                 isLoading: false
            //             }
            //         });
            //     }
            // }
            // else{
            //     dispatch({
            //         type: 'SET_CUSTOMDIALOG', customDialog: {
            //             open: false,
            //             message: 'Please wait for a while...',
            //             severity: 'info',
            //             isLoading: false
            //         }
            //     });
            // }
        }
        else{
            dispatch({
                type: 'SET_CUSTOMDIALOG', customDialog: {
                    open: true,
                    message: "Unexpected error occured when submitting the assessment, Please try again later!",
                    severity: 'error',
                    isLoading: false
                }
            });
        }
    }
    const processOpenEndedAnswers = (answerBlankOrSameAsHistory) =>{
        
        let openEndedAnswers = [];
        activityContext.openEndedAnswers.forEach(item=>{
            if(item.answer.valueOf() === ""){
                answerBlankOrSameAsHistory.push(item.question.QuestionContent);
            }
            if(item.history.length > 0){
                if(item.history[0].Answer.valueOf() === item.answer.valueOf()){
                    answerBlankOrSameAsHistory.push(item.question.QuestionContent);
                }
            }
            openEndedAnswers.push({
                QuestionId: item.question.Id,
                Answer: item.answer
            });
        });
        // console.log(answerBlankOrSameAsHistory);
        return openEndedAnswers;
    }
    const processSelectedAnswer = () => {
        //console.log("multipleChoiceContents", activityContext.multipleChoiceContents)
        let models = [];
        if (!checkValidation()) {
            //console.log("validation success")
            switch (activityContext.activity.AssessmentType){
                case 'Multiple Choice':
                case 'Multiple Choice and Secret Code':
                    activityContext.multipleChoiceContents.forEach(item => {
                        models.push(item.selectedAnswer);
                    })
                    break;
                case 'Multiple Answers':
                case 'Multiple Answers and Secret Code':
                    activityContext.multipleChoiceContents.forEach(item => {
                        item.answers.forEach(element => {
                            if (element.isChecked) {
                                models.push(element);
                            }
                        });
                    });
                    break;
                case 'Secret Code':
                    models.push({ QuestionId: activityContext.activity.QuestionViewModels[0].Id, Option: activityContext.secretCode })
                    break;
                default:
                    break;
            }
        }
        return models;
    }

    const checkValidation = () => {
        let isError = false;
        if (activityContext.multipleChoiceContents.length > 0) {
            if (activityContext.activity.AssessmentType === 'Multiple Choice' || activityContext.activity.AssessmentType === 'Multiple Choice and Secret Code') {
                activityContext.multipleChoiceContents.map(item => {
                    if (Object.keys(item.selectedAnswer).length === 0) {
                        inputSnackBarDetails("Please select at least one choice for each question", 'error');
                        return isError = true;
                    }
                })
            }
            else if (activityContext.activity.AssessmentType === 'Multiple Answers' || activityContext.activity.AssessmentType === 'Multiple Answers and Secret Code') {
                activityContext.multipleChoiceContents.map(item => {
                    let checkedCount = item.answers.filter(element => element.isChecked === true).length;
                    if (checkedCount !== item.limit) {
                        inputSnackBarDetails("Please check all the correct answers for each question", 'error');
                        return isError = true;
                    }
                })
            }
        }
        if (activityContext.isSecretCode) {
            if (activityContext.secretCode.length < 1) {
                inputSnackBarDetails("Please provide your secret code", 'error');
                return isError = true;
            }
        }
        return isError;
    }

    const handleClickTabs = (item) => {
        switch (item) {
            case "content":
                activityContext.tabs.content = true;
                activityContext.tabs.assessment = false;
                dispatch({ type: 'SET_TABS', tabs: activityContext.tabs });
                break;
        }
    }

    if (activityContext.loading) return <Loading />;

    return (
        /**
         * Add dialog informing students that what they are attempting.
         * Add dialog upon completing quiz telling them results of their quiz.
         */
        <ActivityContext.Provider value={{ activityContext, challengeId, dispatch }}>
            <Grid container direction="column" justify='center'>
                {(activityContext.multipleChoiceContents.length > 0) &&
                    <>
                        {activityContext.multipleChoiceContents[0].question.AssessmentType === "Multiple Choice" ?
                            <List>
                                {activityContext.multipleChoiceContents.map((content, index) => (
                                    <div key={index}>
                                        <Grid container>
                                            <Grid item xs={12} sm={12}>
                                                <Typography classes={{ root: classes.rootTitle }}>{content.question.QuestionContent}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl component="fieldset" classes={{ root: classes.rootAnswers }}>
                                                    <RadioGroup aria-label="mc" name="mc1" value={Object.keys(content.selectedAnswer).length === 0 ? null : content.selectedAnswer.Id}
                                                        onChange={(event) => {
                                                            content.selectedAnswer = getCurrentAnswerObject(content.answers, event.target.value)
                                                            activityContext.multipleChoiceContents[index] = content
                                                            dispatch({ type: 'SET_MULTIPLECHOICE_CONTENTS', multipleChoiceContents: activityContext.multipleChoiceContents });
                                                        }}>
                                                        {content.answers.map((answer, innerIndex) => (
                                                            <FormControlLabel key={innerIndex} value={answer.Id}
                                                                control={<Radio />}
                                                                label={<Typography classes={{ root: classes.rootDescription }}>{answer.Option}</Typography>}
                                                            />
                                                        ))}
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </div>
                                ))}
                            </List>
                            : 
                            <List >
                                {/* <MAQAssessment onChangeOption = {onChangeOption} content = {content} divKey = {index} ></MAQAssessment> */}
                                {activityContext.multipleChoiceContents.map((content, index) => (
                                    <div key={index}>
                                        <Grid container>
                                            <Grid item xs={12} sm={12}>
                                                <Typography classes={{ root: classes.rootTitle }}>{content.question.QuestionContent} ( Please select {content.limit} correct {content.limit > 1 ? "answers" : "answer"} )</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl component="fieldset" classes={{ root: classes.rootAnswers }}>
                                                    {content.answers.map((answer, innerIndex) => (
                                                        <FormGroup key={innerIndex}>
                                                            <FormControlLabel
                                                                control={<Checkbox icon={<CheckBoxOutlineBlankTwoToneIcon classes={{ root: classes.checkbox }} />} checkedIcon={<CheckBoxOutlinedIcon />} checked={answer.isChecked} onChange={handleChangeCheckbox(answer, content)} value={answer.Option} />}
                                                                label={<Typography classes={{ root: classes.rootDescription }}>{answer.Option}</Typography>}
                                                            />
                                                        </FormGroup>
                                                    ))}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <br />
                                    </div>
                                ))}
                            </List>
                        }
                    </>
                }
                {
                    activityContext.openEndedAnswers.length > 0 &&
                    <>
                    <List>
                    {activityContext.openEndedAnswers.map ((content,index) => (
                        <div key = {index}>
                            <Grid container classes = {{root: classes.assessmentBox}}>
                                <Grid item xs = {12} sm = {12}>
                                    <Typography classes={{ root: classes.rootTitle }}>{content.question.QuestionContent}</Typography>
                                </Grid>
                                <Grid item xs = {12} sm = {12}>
                                    <SunEditor
                                        setOptions = {{
                                            height:'auto',
                                            minHeight: '300px',
                                            maxHeight: '450px',
                                            width:'auto',
                                            minWidth:'400px',
                                            maxWidth:'800px',
                                            buttonList: [
                                                ['undo', 'redo',
                                                'font', 'fontSize', 'formatBlock',
                                                'paragraphStyle', 'blockquote',
                                                'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript',
                                                'fontColor', 'hiliteColor', 'textStyle',
                                                'removeFormat',
                                                'outdent', 'indent',
                                                'align',
                                                'horizontalRule', 'list','table',
                                                'fullScreen', 'showBlocks'
                                                ]
                                            ],
                                            tagsBlacklist: 'figure|figcaption|img|iframe|audio|video|svg|path|applet|script|style|link',
                                            pasteTagsBlacklist: 'figure|figcaption|img|iframe|audio|video|svg|path|applet|script|style|link',
                                            attributesBlacklist:'target|href|download|rel|src|alt|class|type|controls|data-format|data-size|data-file-size|data-file-name|data-origin|data-align|data-image-link|data-rotate|data-proportion|data-percentage|origin-size|data-exp|data-font-size',
                                            plugins:[align,font,fontColor,fontSize,formatBlock,hiliteColor,horizontalRule,lineHeight,list,table,textStyle,paragraphStyle,blockquote]
                                        }}
                                        setContents = {content.answer}
                                        onChange = {handleOpenAnswerChange(index,content.answer)}
                                        onKeyDown = {()=>{setDisableSubmit(true)}}
                                    />
                                </Grid>
                                <Grid container alignItems ={"flex-start"} justify = {"flex-start"}>
                                    <Grid item xs = {12} sm = {8}>
                                        <Typography classes={{ root: classes.rootSubHeader }}>Previous answer: </Typography>
                                        <List>
                                            {content.history.map((history,historyKey)=>(
                                                <Grid item key = {historyKey}>
                                                <SunEditor
                                                    showToolbar={false}
                                                    enableToolbar={false}
                                                    disable={true}
                                                    setOptions={{
                                                        height: 'auto',
                                                        minHeight: '150px',
                                                        maxHeight: '300px',
                                                        width:"auto",
                                                        minWidth:'300px',
                                                        maxWidth:'600px',
                                                        resizingBar: false,
                                                    }}
                                                    toggleFullScreen={true}
                                                    setContents = {history.Answer}
                                                    showController={false}
                                                />
                                                </Grid>
                                            ))}
                                        </List>
                                    </Grid>
                                    <Grid item>
                                        <Grid item>
                                            <Typography classes = {{root: classes.rootSubHeader}}>Feedback from instructor for previous answer</Typography>
                                        </Grid>
                                        <List>
                                            <Grid item>
                                                <SunEditor
                                                    showToolbar={false}
                                                    enableToolbar={false}
                                                    disable={true}
                                                    setOptions={{
                                                        height: 'auto',
                                                        minHeight: '150px',
                                                        maxHeight: '300px',
                                                        width:"auto",
                                                        minWidth:'300px',
                                                        maxWidth:'600px',
                                                        resizingBar: true,
                                                    }}
                                                    setContents = {content.remarks}
                                                >
                                                </SunEditor>
                                            </Grid>
                                        </List>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    ))
                    }
                    </List>
                    </>
                }
                {activityContext.isSecretCode &&
                // <SecretCodeAssessment onChangeOption = {onChangeOption} content = {content} divKey = {index} ></SecretCodeAssessment>
                    <Grid container direction="column" justify="center" alignItems="center">
                        <TextField id="outlined-basic" InputLabelProps={{ shrink: false }} label={!activityContext.secretCode ? "Secret Code" : ""} color="secondary" variant="outlined"
                            value={activityContext.secretCode}
                            onChange={handleChange}
                            classes={{ root: classes.rootTextField }}
                        />
                    </Grid>
                }
            </Grid>
            <Grid container direction="column" justify="center" alignItems="center">
                <Chip
                    disabled = {disableSubmit}
                    classes={{ root: classes.rootSubmit }}
                    label='Submit'
                    onClick={() => {
                        clickSubmitAssessment();
                        }
                    }
                />
            </Grid>
            <Dialog
                open = {confirmFlag}
            >
                <DialogTitle id="alert-dialog-title" className="idletimeoutmodal__dialog__title">
                    <div className="adventurelearn__header">Submit Answer</div>
                </DialogTitle>
                <DialogContent dividers = {true}>
                    {sameAnswerFlag ? confirmMessage : "Are you sure you want to submit your answers?"}
                </DialogContent>
                <DialogActions>
                    <Button className="adventurelearn__dialogOk" autoFocus onClick = {handleConfirmSubmit}>Submit</Button>
                    <Button className="adventurelearn__dialogCancel" onClick = {handleCloseConfirmDialog}>Cancel</Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                key={`bottom, center`}
                open={snackBarDetails.open}
                autoHideDuration={6000}
                onClose={handleSnackBarClose}>
                <Alert onClose={handleSnackBarClose} severity={snackBarDetails.type}>
                    {snackBarDetails.message}
                </Alert>
            </Snackbar>
            <CustomDialog />
            <Hidden lgUp>
                <Chip icon={<ArrowBackIcon />}
                    style={{ position: "fixed", bottom: '15px', right: '5px' }}
                    color="secondary"
                    label="Content"
                    clickable
                    onClick={() => handleClickTabs("content")}
                />
            </Hidden>
        </ActivityContext.Provider>
    )
}

export default AssessmentContainer;